"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetSenderShops;

var _lib = require("../../../../lib");

var _reactRedux = require("react-redux");

function useGetSenderShops() {
  var shops = (0, _reactRedux.useSelector)(_lib.selectShops);
  return shops.filter(function (item) {
    return !!item['transferRoutes'].length;
  });
}